import { Fragment } from 'react';
import { PmiBodyTableCell } from 'shell/components/shared/table-custom/body';
import { PmiTableRow } from 'shell/components/shared/table/row';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Tooltip } from '@mui/material';
import { NotesTextItemVM } from 'civil-status/view-models/notes-text-list';
import { CivilStatusAuthorizations } from 'shell/authorizations/civil-status';
import { Edit, Visibility } from '@mui/icons-material';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';

export const authsRowNotesText = {
  read: [CivilStatusAuthorizations.AnnotazioneQuery],
  delete: [CivilStatusAuthorizations.AnnotazioneDelete],
  update: [CivilStatusAuthorizations.AnnotazioneUpdate],
  add: [CivilStatusAuthorizations.AnnotazioneAdd],
};

interface TableRowComponentProps {
  item: NotesTextItemVM;
  onTrashPress: (item: NotesTextItemVM) => void;
  onVisibilityPress: (item: NotesTextItemVM) => void;
  onEditPress: (item: NotesTextItemVM) => void;
}

const TableRowComponent = ({
  item,
  onTrashPress,
  onVisibilityPress,
  onEditPress,
}: TableRowComponentProps): React.ReactElement => {
  const auths = useActionAuthorization(authsRowNotesText);

  return (
    <Fragment>
      <PmiTableRow>
        <PmiBodyTableCell scope="row">
          <pre
            style={{
              overflow: 'auto',
              maxHeight: '100px',
            }}
          >
            {item.title}
          </pre>
        </PmiBodyTableCell>
        <PmiBodyTableCell scope="row">
          <pre
            style={{
              overflowY: 'auto',
              whiteSpace: 'initial',
              maxHeight: '40px',
            }}
          >
            {item.text}
          </pre>
        </PmiBodyTableCell>
        <PmiBodyTableCell scope="row">
          <pre
            style={{
              overflow: 'auto',
              maxHeight: '100px',
            }}
          >
            {item.type}
          </pre>
        </PmiBodyTableCell>
        <PmiBodyTableCell scope="row">
          <div className="pmi-d-flex">
            <Tooltip
              arrow
              title={
                auths.read
                  ? 'Visualizza'
                  : "Non si ha l'autorizzazione per accedere a questa funzionalità"
              }
            >
              <span>
                <IconButton
                  aria-label="visualizza"
                  component="span"
                  onClick={() => onVisibilityPress(item)}
                  disabled={!auths.read}
                >
                  <Visibility />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip
              arrow
              title={
                auths.update
                  ? 'Aggiorna'
                  : "Non si ha l'autorizzazione per accedere a questa funzionalità"
              }
            >
              <span>
                <IconButton
                  aria-label="modifica"
                  component="span"
                  onClick={() => onEditPress(item)}
                  disabled={!auths.update}
                >
                  <Edit />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip
              arrow
              title={
                auths.delete
                  ? 'Elimina'
                  : "Non si ha l'autorizzazione per accedere a questa funzionalità"
              }
            >
              <span>
                <IconButton
                  color="error"
                  aria-label="elimina"
                  component="span"
                  disabled={!auths.delete}
                  onClick={() => onTrashPress(item)}
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        </PmiBodyTableCell>
      </PmiTableRow>
    </Fragment>
  );
};

TableRowComponent.displayName = 'Table row component';

export default TableRowComponent;
